// extracted by mini-css-extract-plugin
export var feedItem = "links-module--feedItem--AFk1f";
export var landingLink = "links-module--landingLink--Ep6P6";
export var navItem = "links-module--navItem--iX+Jj";
export var sceneLink = "links-module--sceneLink--WScjR";
export var siteTitle = "links-module--siteTitle--jsPbG";